export type BaseProps = {
  alignH?: string
  alignV?: string
  alignment?: string
  bg?: string
  border?: boolean
  borderBottom?: boolean
  borderColor?: string
  borderLeft?: boolean
  borderRight?: boolean
  borderTop?: boolean
  col?: string
  color?: string
  container?: boolean
  direction?: string
  even?: boolean
  evenItems?: string
  flex?: boolean
  gap?: string
  grid?: boolean
  grow?: boolean
  lg?: string
  margin?: string
  marginBottom?: boolean
  marginLeft?: boolean
  marginRight?: boolean
  marginTop?: boolean
  md?: string
  noGap?: boolean
  padding?: string
  paddingBottom?: boolean
  paddingLeft?: boolean
  paddingRight?: boolean
  paddingTop?: boolean
  rounded?: boolean
  roundedFull?: boolean
  roundedLg?: boolean
  roundedSm?: boolean
  shadow?: boolean
  shadowColor?: string
  shadowLg?: boolean
  shrink?: boolean
  sm?: string
  width?: string
  wrap?: boolean
  xl?: string
}

export const BASE_PROPS_DEFAULTS = {
  alignH: '',
  alignV: '',
  alignment: 'left',
  bg: '',
  borderColor: '',
  col: '',
  color: '',
  direction: '',
  evenItems: '',
  flex: true,
  gap: '1',
  lg: '',
  margin: '',
  md: '',
  padding: '2',
  sm: '',
  width: '100',
  xl: '',
}
